import ExampleStore from './example.store';
import Tags from './tags.store';
import Associations from './associations.store';

export default { ExampleStore, Tags, Associations };